import { Injectable, OnDestroy } from '@angular/core';
import { LiveValue, LiveValueService } from '@core/services/live-value.service';
import { ReplaySubject, Subject, Subscription } from 'rxjs';

@Injectable()
export class DistributedLiveValuesService implements OnDestroy {
  private _valueSubscriptions: { [signalId: string]: Subject<LiveValue>[] };
  private _serviceSubscription: Subscription;
  private _asyncSubscriptions: ReplaySubject<string>;
  private _serviceSubject: Subject<LiveValue[]>;
  private id: string;

  constructor(private readonly _liveValueService: LiveValueService) {}

  public ngOnDestroy(): void {
    if (this._serviceSubscription) {
      this._serviceSubscription.unsubscribe();
    }

    if (this._serviceSubject) {
      this._serviceSubject.complete();
      this._serviceSubject = undefined;
    }

    if (this._valueSubscriptions) {
      const keys = Object.keys(this._valueSubscriptions);
      keys.map((key) => {
        this._valueSubscriptions[key].map((sub) => {
          sub.complete();
        });
      });
    }
  }

  public subscribeSignal(signalId: string, callBack: Subject<LiveValue>): void {
    const subs = this._valueSubscriptions[signalId];
    if (subs) {
      subs.push(callBack);
    } else {
      this._valueSubscriptions[signalId] = [callBack];
      this._subscribeAsync(signalId);
    }
  }

  private _subscribeAsync(signalId: string): void {
    this._asyncSubscriptions.next(signalId);
  }

  private _distribute(data: LiveValue[]): void {
    data.map((liveValue: LiveValue) => {
      const subs = this._valueSubscriptions[liveValue.identifier];
      if (subs) {
        subs.map((s) => {
          s.next(liveValue);
        });
      }
    });
  }

  public establishConnection(): void {
    this._valueSubscriptions = {};
    this._asyncSubscriptions = new ReplaySubject();

    if (this._serviceSubject) {
      this._serviceSubject.complete();
      this._serviceSubject = undefined;
    }
    this._serviceSubject = new Subject<LiveValue[]>();
    this._serviceSubscription = this._serviceSubject.subscribe((data: LiveValue[]) => {
      this._distribute(data);
    });

    this.id = this._liveValueService.buildConnection(this._serviceSubject);
    this._liveValueService.startConnection(this.id).subscribe(() => {
      this._liveValueService.setOnPush(this.id, true);
      this._asyncSubscriptions.asObservable().subscribe((id) => {
        this._liveValueService.subscribeManyForSignals(this.id, [id]);
      });
    });
  }
}
